import React from 'react';
import LegalPageLayout from './LegalPageLayout';

function TermsConditions() {
	return (
		<LegalPageLayout title="Terms & Conditions">
			<p>
				By using Movie Quotes Guesser, you agree to these terms. If you do not agree, please do not
				use the site.
			</p>
			<h2>Use of the Site</h2>
			<ul>
				<li>Use the site for personal, non-commercial entertainment.</li>
				<li>Do not attempt to disrupt, reverse engineer, or exploit the service.</li>
				<li>Respect intellectual property for content displayed on the site.</li>
			</ul>
			<h2>Content & Availability</h2>
			<p>
				The game is provided on an "as-is" and "as-available" basis. We may update or remove
				features at any time without notice.
			</p>
			<h2>Third-Party Links</h2>
			<p>
				We may link to third-party sites. We are not responsible for their content or policies.
			</p>
			<h2>Limitation of Liability</h2>
			<p>
				To the extent permitted by law, Movie Quotes Guesser is not liable for indirect or
				consequential damages arising from your use of the site.
			</p>
			<h2>Contact</h2>
			<p>
				Questions about these terms? Email{' '}
				<a href="mailto:contact@moviequotesguesser.com">contact@moviequotesguesser.com</a>.
			</p>
		</LegalPageLayout>
	);
}

export default TermsConditions;
